export const SPECIAL_REFUND_DOCTYPES = new Set([174, 175, 176, 177, 178, 179]);

export const DEFAULT_RETURN_DOCTYPE = 74;
export const DEFAULT_ORDER_DOCTYPE = 11;
export const DEFAULT_VIRTUAL_DOCTYPE = 7;
export const DEFAULT_RESERVED_ORDER_DOCTYPE = 88;
export const DEFAULT_SAPAKIM_DOCTYPE = 17;

export const ALL_CLIENTSIDE_ORDER_DOCTYPES = new Set([11, 170, 171, 172, 88]);

export const SPECIAL_RESERVED_ORDER_DOCTYPES = new Set([89, 90, 91, 92]);

// service-call doctypes: 600-620
export const SERVICE_CALL_DOCTYPE_TECHNOTIRE = 600;

// export const SERVICE_CALL_DOCTYPES = new Array(20).fill(0).map((_, i) => 600 + +i);

export const VAN_SALE_DOCTYPES = new Set([650, 651, 652, 653, 654, 655, 656, 657, 658, 659, 660]);

export const DOCTYPE_DEFAULT_NAME: Record<number, string> = {
	88: 'הזמנה משריון',
	11: 'הזמנה',
	170: 'הזמנה נוספת',
	171: 'הזמנה נוספת 1',
	172: 'הזמנה נוספת 2',
	74: 'ת. החזרה',
	7: 'הצעת מחיר',
};

export const RECLAMATION_DOCTYPE = 555;
export const RECLAMATION_RALLYANCE_DOCTYPE = 1110;

export const STOCKTAKE_DOCTYPE = 288;

export const DEFAULT_DOCTYPE_BY_TYPE = {
	virtual: DEFAULT_VIRTUAL_DOCTYPE,
	order: DEFAULT_ORDER_DOCTYPE,
	return: DEFAULT_RETURN_DOCTYPE,
	reclamation: RECLAMATION_DOCTYPE,
	'reclamation-rallyance': RECLAMATION_RALLYANCE_DOCTYPE,
} as const;

export const LIKUT_KABALA_ORDER_DOCTYPES = [11, 8] as const;
export const LIKUT_KABALA_RETURN_DOCTYPES = [74, 7] as const;

export const LIKUT_SFIRA_DOCTYPE = 456;
